import { keymap } from '@codemirror/view';
import { insertNewlineAndIndent } from '@codemirror/commands';

const jsonKeymap = keymap.of([
  {
    key: 'Enter',
    run: insertNewlineAndIndent,
    shift: insertNewlineAndIndent,
  },
]);

export default jsonKeymap;
